import { render, staticRenderFns } from "./UpdateDeposit.vue?vue&type=template&id=2eb3c93a"
import script from "./UpdateDeposit.vue?vue&type=script&lang=js"
export * from "./UpdateDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports